"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlansByAge = exports.TransformProductDefinitions = exports.GetProductSetsForBrand = exports.GetProductName = exports.GetPlansBySpeciesAndAge = exports.GetLevelsOfCoverFromExcessOptions = exports.GetInitialSelectedOptionsMergedPlans = exports.GetInitialSelectedOptionsAllPlans = exports.GetInitialPlanOptionsState = exports.GetFootnoteNumber = exports.GetExcessCode = exports.GetAllProductGroupsKeyedByPlanNumber = exports.GetAllPlansKeyedByPlanNumber = exports.GetAllLevelsOfCover = void 0;
var _planDisplayOrdersByBrand = require("../constants/planDisplayOrdersByBrand");
var _environmentHelper = require("./environmentHelper");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var GetLevelsOfCoverFromExcessOptions = exports.GetLevelsOfCoverFromExcessOptions = function GetLevelsOfCoverFromExcessOptions(_ref) {
  var upmExcessOptions = _ref.upmExcessOptions,
    staffLevelsOfCover = _ref.staffLevelsOfCover,
    petSureStaffMode = _ref.petSureStaffMode;
  return upmExcessOptions.reduce(function (acc, _ref2) {
    var levelOfCover = _ref2.levelOfCover;
    var isStaffLevelOfCover = staffLevelsOfCover && staffLevelsOfCover.indexOf(levelOfCover) !== -1;
    if (acc.indexOf(levelOfCover) === -1 && (petSureStaffMode || !isStaffLevelOfCover)) {
      acc.push(levelOfCover);
    }
    return acc;
  }, []);
};
var getDefaultIndex = function getDefaultIndex(_ref3) {
  var brandTextElements = _ref3.brandTextElements,
    labelKey = _ref3.labelKey,
    maxDefaultIndex = _ref3.maxDefaultIndex;
  if (!brandTextElements) {
    return 0;
  }
  var groupMatch = brandTextElements.labelGroups.find(function (labelGroup) {
    var itemMatch = Object.keys(labelGroup.items).find(function (itemKey) {
      return itemKey === labelKey;
    });
    if (itemMatch) {
      return true;
    }
    return false;
  });
  var defaultIndex = groupMatch && groupMatch.items[labelKey].defaultValueIndex;
  return defaultIndex && defaultIndex <= maxDefaultIndex ? defaultIndex : 0;
};
var GetInitialSelectedOptionsMergedPlans = exports.GetInitialSelectedOptionsMergedPlans = function GetInitialSelectedOptionsMergedPlans(_ref4) {
  var BaseProducts = _ref4.BaseProducts,
    brandTextElements = _ref4.brandTextElements,
    petSureStaffMode = _ref4.petSureStaffMode;
  return Object.entries(BaseProducts).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      productGroup = _ref6[0],
      basePlan = _ref6[1];
    var routineCare = basePlan.routineCare,
      upmExcessOptions = basePlan.upmExcessOptions,
      dental = basePlan.dental,
      staffLevelsOfCover = basePlan.staffLevelsOfCover,
      limits = basePlan.limits;
    var baseLevelsOfCover = GetLevelsOfCoverFromExcessOptions({
      upmExcessOptions: upmExcessOptions,
      staffLevelsOfCover: staffLevelsOfCover,
      petSureStaffMode: petSureStaffMode
    });
    var defaultExcessIndex = getDefaultIndex({
      brandTextElements: brandTextElements,
      labelKey: 'excess',
      maxDefaultIndex: upmExcessOptions.length - 1
    });
    var defaultLevelOfCoverIndex = getDefaultIndex({
      brandTextElements: brandTextElements,
      labelKey: 'levelOfCover',
      maxDefaultIndex: baseLevelsOfCover.length - 1
    });
    var amount = limits.annualLimit.amount;
    acc[productGroup] = _objectSpread(_objectSpread(_objectSpread({
      excess: "".concat(upmExcessOptions[defaultExcessIndex].excess)
    }, routineCare ? {
      routineCare: 'yes'
    } : {
      routineCare: 'no'
    }), dental ? {
      dental: 'yes'
    } : {
      dental: 'no'
    }), {}, {
      levelOfCover: baseLevelsOfCover[defaultLevelOfCoverIndex],
      annualLimit: amount
    });
    return acc;
  }, {});
};
var GetInitialSelectedOptionsAllPlans = exports.GetInitialSelectedOptionsAllPlans = function GetInitialSelectedOptionsAllPlans(_ref7) {
  var AllPlans = _ref7.AllPlans,
    brandTextElements = _ref7.brandTextElements,
    petSureStaffMode = _ref7.petSureStaffMode;
  return Object.entries(AllPlans).reduce(function (acc, _ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
      planKey = _ref9[0],
      plan = _ref9[1];
    var planNumber = plan.planNumber,
      routineCare = plan.routineCare,
      upmExcessOptions = plan.upmExcessOptions,
      dental = plan.dental,
      levelsOfCover = plan.levelsOfCover,
      staffLevelsOfCover = plan.staffLevelsOfCover,
      stepDownLevelsOfCover = plan.stepDownLevelsOfCover,
      limits = plan.limits;
    var amount = limits.annualLimit.amount;
    var defaultExcessIndex = getDefaultIndex({
      brandTextElements: brandTextElements,
      labelKey: 'excess',
      maxDefaultIndex: upmExcessOptions.length - 1
    });
    var defaultLevelOfCoverIndex = getDefaultIndex({
      brandTextElements: brandTextElements,
      labelKey: 'levelOfCover',
      maxDefaultIndex: levelsOfCover.length - 1
    });
    acc[planNumber] = _objectSpread(_objectSpread(_objectSpread({
      excess: "".concat(upmExcessOptions[defaultExcessIndex].excess)
    }, routineCare ? {
      routineCare: 'yes'
    } : {
      routineCare: 'no'
    }), dental ? {
      dental: 'yes'
    } : {
      dental: 'no'
    }), {}, {
      levelOfCover: levelsOfCover[defaultLevelOfCoverIndex] || stepDownLevelsOfCover && stepDownLevelsOfCover[defaultLevelOfCoverIndex] || petSureStaffMode && staffLevelsOfCover && staffLevelsOfCover[defaultLevelOfCoverIndex] || [],
      levelsOfCover: levelsOfCover,
      annualLimit: amount
    });
    return acc;
  }, {});
};
var GetInitialPlanOptionsState = exports.GetInitialPlanOptionsState = function GetInitialPlanOptionsState(_ref10) {
  var BaseProducts = _ref10.BaseProducts,
    AllPlans = _ref10.AllPlans,
    brandTextElements = _ref10.brandTextElements,
    petSureStaffMode = _ref10.petSureStaffMode;
  return {
    merged: GetInitialSelectedOptionsMergedPlans({
      BaseProducts: BaseProducts,
      brandTextElements: brandTextElements,
      petSureStaffMode: petSureStaffMode
    }),
    allPlans: GetInitialSelectedOptionsAllPlans({
      AllPlans: AllPlans,
      brandTextElements: brandTextElements,
      petSureStaffMode: petSureStaffMode
    })
  };
};
var GetAllProductGroupsKeyedByPlanNumber = exports.GetAllProductGroupsKeyedByPlanNumber = function GetAllProductGroupsKeyedByPlanNumber(_ref11) {
  var productDefinitions = _ref11.productDefinitions;
  return Object.entries(productDefinitions).reduce(function (acc, _ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
      productGroup = _ref13[0],
      plans = _ref13[1];
    Object.keys(plans).forEach(function (planNo) {
      acc[planNo] = productGroup;
    });
    return acc;
  }, {});
};
var GetAllPlansKeyedByPlanNumber = exports.GetAllPlansKeyedByPlanNumber = function GetAllPlansKeyedByPlanNumber(_ref14) {
  var productDefinitions = _ref14.productDefinitions;
  return Object.entries(productDefinitions).reduce(function (acc, _ref15) {
    var _ref16 = _slicedToArray(_ref15, 2),
      productGroup = _ref16[0],
      plans = _ref16[1];
    Object.entries(plans).forEach(function (_ref17) {
      var _ref18 = _slicedToArray(_ref17, 2),
        planNo = _ref18[0],
        planDetails = _ref18[1];
      acc[planNo] = planDetails;
    });
    return acc;
  }, {});
};
var GetProductName = exports.GetProductName = function GetProductName(_ref19) {
  var productDefinition = _ref19.productDefinition,
    planProductGroup = _ref19.planProductGroup,
    groupedProductNames = _ref19.groupedProductNames,
    productsAreMerged = _ref19.productsAreMerged;
  var externalName = productDefinition.externalName;
  if (groupedProductNames && productsAreMerged && groupedProductNames[planProductGroup]) {
    return groupedProductNames[planProductGroup];
  }
  return externalName;
};
var GetExcessCode = exports.GetExcessCode = function GetExcessCode(_ref20) {
  var upmExcessOptions = _ref20.upmExcessOptions,
    levelOfCover = _ref20.levelOfCover,
    excessAmount = _ref20.excessAmount;
  var excessOption = upmExcessOptions.find(function (upmExcessOption) {
    return upmExcessOption.levelOfCover.toString() === levelOfCover.toString() && upmExcessOption.excess.toString() === excessAmount.toString();
  });
  if (!excessOption) {
    throw Error("No matching excess found within\n      ".concat(JSON.stringify(upmExcessOptions, null, 4)));
  }
  return excessOption.excessCode;
};
var GetAllLevelsOfCover = exports.GetAllLevelsOfCover = function GetAllLevelsOfCover(_ref21) {
  var planNumber = _ref21.planNumber,
    productDefinition = _ref21.productDefinition,
    AddOnsMap = _ref21.AddOnsMap,
    AllPlans = _ref21.AllPlans,
    petSureStaffMode = _ref21.petSureStaffMode;
  var _productDefinition$is = productDefinition.isVariant,
    isVariant = _productDefinition$is === void 0 ? false : _productDefinition$is,
    basePlanNo = productDefinition.basePlanNo;
  var basePlanNumber = isVariant ? basePlanNo : planNumber;
  var levelsOfCover = AllPlans["Plan_".concat(basePlanNumber)].levelsOfCover;
  var stepDownLevelsOfCover = [];
  var allLevelsOfCover = _toConsumableArray(levelsOfCover || []);

  // If the plan has variants check the levels of cover for each
  if (AddOnsMap[basePlanNumber]) {
    Object.values(AddOnsMap[basePlanNumber]).forEach(function (variantAddOnDefinition) {
      variantAddOnDefinition.levelsOfCover.forEach(function (variantLevelOfCover) {
        allLevelsOfCover.push(variantLevelOfCover);
      });
      if (variantAddOnDefinition.stepDownLevelsOfCover) {
        variantAddOnDefinition.stepDownLevelsOfCover.forEach(function (variantLevelOfCover) {
          stepDownLevelsOfCover.push(variantLevelOfCover);
          if (petSureStaffMode) {
            allLevelsOfCover.push(variantLevelOfCover);
          }
        });
      }
    });
  }
  return {
    levelsOfCover: _toConsumableArray(new Set(allLevelsOfCover)).sort(),
    stepDownLevelsOfCover: _toConsumableArray(new Set(stepDownLevelsOfCover)).sort()
  };
};
var TransformProductDefinitions = exports.TransformProductDefinitions = function TransformProductDefinitions(_ref22) {
  var brand = _ref22.brand,
    productDefinitions = _ref22.productDefinitions,
    speciesFilter = _ref22.speciesFilter,
    staffMode = _ref22.staffMode,
    debugMode = _ref22.debugMode,
    petSureStaffMode = _ref22.petSureStaffMode,
    brandTextElements = _ref22.brandTextElements,
    quotesContext = _ref22.quotesContext,
    ageFilter = _ref22.ageFilter;
  var DisplayOrders = _planDisplayOrdersByBrand.CustomDisplayOrdersByBrand[brand];
  var hasProducts = Object.keys(productDefinitions).length > 0;
  var sortedProductDefinitions = DisplayOrders && hasProducts ? DisplayOrders.reduce(function (acc, productGroup) {
    if (productDefinitions[productGroup]) {
      acc[productGroup] = productDefinitions[productGroup];
    } else if (debugMode) {
      /* eslint-disable-next-line no-console */
      console.warn("Missing productGroup ".concat(productGroup, " for brand ").concat(brand));
    }
    return acc;
  }, {}) : productDefinitions;
  var filteredProducts = ageFilter ? getPlansByAge(productDefinitions, ageFilter) : sortedProductDefinitions;
  var ProductGroups = Object.keys(productDefinitions);
  var ProductGroupsKeyedByPlanNumber = GetAllProductGroupsKeyedByPlanNumber({
    productDefinitions: productDefinitions
  });

  // Work out what groupings need to be applied
  var ProductGroupingsBySpecies = _planDisplayOrdersByBrand.CustomGroupingsByBrandAndSpecies[brand] ? Object.entries(_planDisplayOrdersByBrand.CustomGroupingsByBrandAndSpecies[brand]).reduce(function (acc, _ref23) {
    var _ref24 = _slicedToArray(_ref23, 2),
      groupKey = _ref24[0],
      groupValue = _ref24[1];
    if (speciesFilter === 'all' || groupKey === speciesFilter) {
      return [].concat(_toConsumableArray(acc), _toConsumableArray(groupValue));
    }
    return acc;
  }, []) : [];

  // Only replaced the products used in base, uses filtered products 
  var BaseProducts = Object.entries(filteredProducts).reduce(function (acc, _ref25) {
    var _ref26 = _slicedToArray(_ref25, 2),
      productGroup = _ref26[0],
      plans = _ref26[1];
    var basePlan = Object.values(plans).filter(function (plan) {
      return plan.isBasePlan || !plan.isVariant;
    });
    if (basePlan.length !== 1) {
      /* eslint-disable-next-line no-console */
      console.log("Issue detected with base plan for ".concat(brand, " ").concat(productGroup, ". There should be exactly 1 match. Found ").concat(basePlan.length));
    }

    /* eslint-disable-next-line prefer-destructuring */
    acc[productGroup] = basePlan[0];
    return acc;
  }, {});
  var AllPlans = Object.values(sortedProductDefinitions).reduce(function (acc, plans) {
    return _objectSpread(_objectSpread({}, acc), plans);
  }, {});
  var AddOnsMap = Object.entries(sortedProductDefinitions).reduce(function (acc, _ref27) {
    var _ref28 = _slicedToArray(_ref27, 2),
      productGroup = _ref28[0],
      plans = _ref28[1];
    var variantsPlans = Object.values(plans).filter(function (plan) {
      return plan.isVariant;
    });
    variantsPlans.forEach(function (variantPlan) {
      var _variantPlan$addOns = variantPlan.addOns,
        addOns = _variantPlan$addOns === void 0 ? [] : _variantPlan$addOns,
        planNumber = variantPlan.planNumber,
        basePlanNo = variantPlan.basePlanNo,
        levelOfCover = variantPlan.levelOfCover,
        upmExcessOptions = variantPlan.upmExcessOptions,
        staffLevelsOfCover = variantPlan.staffLevelsOfCover,
        stepDown = variantPlan.stepDown,
        limits = variantPlan.limits;
      var variantLevelsOfCover = GetLevelsOfCoverFromExcessOptions({
        upmExcessOptions: upmExcessOptions,
        staffLevelsOfCover: staffLevelsOfCover,
        petSureStaffMode: petSureStaffMode
      });
      if (!addOns || addOns.length === 0) {
        /* eslint-disable-next-line no-console */
        console.warn("Variant plan for ".concat(brand, " ").concat(productGroup, " found with no addons. ").concat(planNumber));
      }
      var baseLevelsOfCover = AllPlans["Plan_".concat(basePlanNo)].levelsOfCover;

      // Check the levels of cover arrays for any differences
      if (!stepDown) {
        variantLevelsOfCover.forEach(function (variantLevelOfCover) {
          if (baseLevelsOfCover.indexOf(variantLevelOfCover) === -1 && addOns.indexOf('levelOfCover') === -1) {
            addOns.push('levelOfCover');
          }
        });
      }
      if (!acc[basePlanNo]) {
        acc[basePlanNo] = [];
      }
      acc[basePlanNo].push(_objectSpread({
        addOns: addOns,
        planNumber: planNumber,
        annualLimit: limits.annualLimit.amount,
        levelOfCover: levelOfCover
      }, stepDown ? {
        stepDownLevelsOfCover: variantLevelsOfCover,
        levelsOfCover: baseLevelsOfCover
      } : {
        levelsOfCover: variantLevelsOfCover
      }));
    });
    return acc;
  }, {});
  var FindMatchingPlanByAddOns = function FindMatchingPlanByAddOns(_ref29) {
    var productGroup = _ref29.productGroup,
      addOns = _ref29.addOns;
    if (!AddOnsMap[productGroup]) {
      return [];
    }
    return AddOnsMap[productGroup].filter(function (plan) {
      return plan.addOns === addOns.join(',');
    });
  };
  var sortGroupedPlansByProductGroup = function sortGroupedPlansByProductGroup(_ref30) {
    var groupedPlans = _ref30.groupedPlans,
      groupDisplayOrders = _ref30.groupDisplayOrders;
    var sortedPlans = [];
    if (DisplayOrders) {
      DisplayOrders.forEach(function (groupKey) {
        if (groupedPlans[groupKey]) {
          sortedPlans.push(groupedPlans[groupKey]);
        }
      });
      return sortedPlans;
    }
    return groupedPlans;
  };
  var sortUngroupedPlansByProductGroup = function sortUngroupedPlansByProductGroup(_ref31) {
    var ungroupedPlans = _ref31.ungroupedPlans,
      groupDisplayOrders = _ref31.groupDisplayOrders,
      groupsKeyedByPlanNumber = _ref31.groupsKeyedByPlanNumber;
    var sortedPlans = [];
    if (DisplayOrders) {
      DisplayOrders.forEach(function (groupKey) {
        Object.values(ungroupedPlans).forEach(function (plan) {
          var planNumber = plan.planNumber;
          if (groupsKeyedByPlanNumber["Plan_".concat(planNumber)] === groupKey) {
            sortedPlans.push(plan);
          }
        });
      });
      return sortedPlans;
    }
    return ungroupedPlans;
  };
  var FilterProducts = function FilterProducts(_ref32) {
    var speciesFilter = _ref32.speciesFilter,
      visiblePlans = _ref32.visiblePlans,
      groupDisplayOrders = _ref32.groupDisplayOrders,
      productsAreGrouped = _ref32.productsAreGrouped,
      groupsKeyedByPlanNumber = _ref32.groupsKeyedByPlanNumber;
    var sortedPlans = productsAreGrouped ? sortGroupedPlansByProductGroup({
      groupedPlans: visiblePlans,
      groupDisplayOrders: groupDisplayOrders
    }) : sortUngroupedPlansByProductGroup({
      ungroupedPlans: visiblePlans,
      groupDisplayOrders: groupDisplayOrders,
      groupsKeyedByPlanNumber: groupsKeyedByPlanNumber
    });
    if (speciesFilter === 'all') {
      return sortedPlans;
    }
    var filteredPlans = Object.entries(visiblePlans).reduce(function (acc, _ref33) {
      var _ref34 = _slicedToArray(_ref33, 2),
        planGroup = _ref34[0],
        plan = _ref34[1];
      if (!plan.petSpecies || plan.petSpecies.length === 0 || plan.petSpecies.includes(speciesFilter)) {
        acc[plan.planNumber] = plan;
      }
      return acc;
    }, {});
    return sortUngroupedPlansByProductGroup({
      ungroupedPlans: filteredPlans,
      groupDisplayOrders: groupDisplayOrders,
      groupsKeyedByPlanNumber: groupsKeyedByPlanNumber
    });
  };
  return {
    DisplayOrders: DisplayOrders,
    ProductGroups: ProductGroups,
    ProductGroupsKeyedByPlanNumber: ProductGroupsKeyedByPlanNumber,
    ProductGroupingsBySpecies: ProductGroupingsBySpecies,
    BaseProducts: BaseProducts,
    AddOnsMap: AddOnsMap,
    AllPlans: AllPlans,
    InitialPlanOptionsState: GetInitialPlanOptionsState({
      BaseProducts: BaseProducts,
      AllPlans: AllPlans,
      brandTextElements: brandTextElements,
      petSureStaffMode: petSureStaffMode
    }),
    FilterProducts: FilterProducts,
    FindMatchingPlanByAddOns: FindMatchingPlanByAddOns
  };
};
var GetProductSetsForBrand = exports.GetProductSetsForBrand = function GetProductSetsForBrand(_ref35) {
  var _ref35$env = _ref35.env,
    env = _ref35$env === void 0 ? 'prod' : _ref35$env,
    _ref35$brand = _ref35.brand,
    brand = _ref35$brand === void 0 ? 'pinscom' : _ref35$brand,
    _ref35$petSureStaffMo = _ref35.petSureStaffMode,
    petSureStaffMode = _ref35$petSureStaffMo === void 0 ? false : _ref35$petSureStaffMo;
  var _GetEnvironmentProduc = (0, _environmentHelper.GetEnvironmentProductFiles)(env),
    productList = _GetEnvironmentProduc.productList,
    publicProducts = _GetEnvironmentProduc.publicProducts,
    staffProducts = _GetEnvironmentProduc.staffProducts;
  var products = productList[brand];
  var hasAvailableProducts = function hasAvailableProducts() {
    return petSureStaffMode ? staffProducts[brand] : publicProducts[brand];
  };
  if (!hasAvailableProducts()) {
    return [];
  }
  var productSet = {};
  Object.entries(products).forEach(function (_ref36) {
    var _ref37 = _slicedToArray(_ref36, 1),
      productGroup = _ref37[0];
    if (petSureStaffMode && productGroup in staffProducts[brand]) {
      productSet[productGroup] = staffProducts[brand][productGroup];
    }
    if (!petSureStaffMode && productGroup in publicProducts[brand]) {
      productSet[productGroup] = publicProducts[brand][productGroup];
    }
    return productSet[productGroup];
  });
  return productSet;
};
var GetFootnoteNumber = exports.GetFootnoteNumber = function GetFootnoteNumber(labelKey, brandFootnotes) {
  var footnoteKeys = Object.keys(brandFootnotes);
  if (footnoteKeys.indexOf(labelKey) !== -1) {
    return footnoteKeys.indexOf(labelKey) + 1;
  }
  return footnoteKeys.indexOf('default') + 1;
};
var GetPlansBySpeciesAndAge = exports.GetPlansBySpeciesAndAge = function GetPlansBySpeciesAndAge(_ref38) {
  var productDefinitions = _ref38.productDefinitions,
    species = _ref38.species,
    ageInDays = _ref38.ageInDays;
  var matchingPlans = Object.values(productDefinitions).reduce(function (acc, productDefinition) {
    var petSpecies = productDefinition.petSpecies,
      _productDefinition$li = productDefinition.limits.ageLimits,
      minAgeDays = _productDefinition$li.minAgeDays,
      maxAgeDays = _productDefinition$li.maxAgeDays;

    // If it doesn't support the species just return
    if (species !== 'all' && petSpecies.length && petSpecies.indexOf(species) === -1) {
      return acc;
    }

    // If there aren't any limits return it
    if (!minAgeDays && !maxAgeDays) {
      acc.push(productDefinition);
      return acc;
    }

    // If there isn't a max just check it is greater than the min
    if (!maxAgeDays && ageInDays > minAgeDays) {
      acc.push(productDefinition);
      return acc;
    }

    // If there isn't a min just check it is less than the max
    if (!minAgeDays && ageInDays < maxAgeDays) {
      acc.push(productDefinition);
      return acc;
    }
    if (ageInDays > minAgeDays && ageInDays < maxAgeDays) {
      acc.push(productDefinition);
    }
    return acc;
  }, []);
  return matchingPlans;
};

/**
 * 
  * Filters plans based on a pet's age in days.
 *
 * @param {Object} plans - A nested object where each key is a plan category (e.g., "cat", "dog") 
 *                         and each value is an object containing multiple plan definitions.
 * @param {number} ageInDays - The age of the pet in days.
 * @returns {Object} - A filtered object containing only the plans that are valid 
 *                     for the given age, grouped by their original category.
 */
var getPlansByAge = exports.getPlansByAge = function getPlansByAge(plans, ageInDays) {
  try {
    // console.log('Getting plans by age...', { plans, ageInDays });

    if (!ageInDays || !plans) {
      throw new Error('No pet or plan provided');
    }
    var filteredPlans = Object.fromEntries(Object.entries(plans).map(function (_ref39) {
      var _ref40 = _slicedToArray(_ref39, 2),
        category = _ref40[0],
        planGroup = _ref40[1];
      var filteredGroup = Object.fromEntries(Object.entries(planGroup).filter(function (_ref41) {
        var _ref42 = _slicedToArray(_ref41, 2),
          planKey = _ref42[0],
          planValue = _ref42[1];
        var _planValue$limits = planValue.limits,
          _planValue$limits2 = _planValue$limits === void 0 ? {} : _planValue$limits,
          _planValue$limits2$ag = _planValue$limits2.ageLimits,
          _planValue$limits2$ag2 = _planValue$limits2$ag === void 0 ? {} : _planValue$limits2$ag,
          minAgeDays = _planValue$limits2$ag2.minAgeDays,
          maxAgeDays = _planValue$limits2$ag2.maxAgeDays;
        if (!minAgeDays && !maxAgeDays) return true;
        if (!maxAgeDays && ageInDays >= minAgeDays) return true;
        if (!minAgeDays && ageInDays <= maxAgeDays) return true;
        return ageInDays >= minAgeDays && ageInDays <= maxAgeDays;
      }));
      return [category, filteredGroup];
    }).filter(function (_ref43) {
      var _ref44 = _slicedToArray(_ref43, 2),
        group = _ref44[1];
      return Object.keys(group).length > 0;
    }) // remove empty categories
    );

    // console.log('Filtered plans:', filteredPlans);

    return filteredPlans;
  } catch (e) {
    return e;
  }
};